import React, { useContext, useEffect, useState } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import '../styles/Home.css';
import { motion } from 'framer-motion';
import { LanguageContext } from '../contexts/LanguageContext';
import { Link } from 'react-router-dom';
import ContactBloc from '../components/ContactBloc';
import profilePic from '../img/profile.png';
import iconArrow from '../img/icon/right-arrow.svg';
import devActivity from '../img/assets/dev-activity.png';
import devConception from '../img/assets/dev-conception.png';
import devDesign from '../img/assets/dev-design.png';
import spiralArrow from '../img/assets/spiral-arrow.png';
import demoOmbraStudio from '../img/homepage/demo-ombrastudio.png'
import demoBloomAura from '../img/homepage/demo-bloomaura.png';
import demoBeaulieu from '../img/homepage/demo-beaulieu.png';
import demoComConseil from '../img/homepage/demo-comconseil.png';
import demoSystemik from '../img/homepage/demo-systemik.png';
import demoOpus from '../img/homepage/demo-opus.png';
import { FaProjectDiagram, FaLaptopCode, FaCogs, FaCode, FaCheckCircle, FaMobileAlt, FaTools, FaPencilRuler } from 'react-icons/fa';

const translations = {
    en: {
        greeting: "Hi, I'm Antoine, freelance web and mobile developer.",
        tagline: 'Boost your business with tailor-made solutions',
        infoline: "As a versatile web developer, I can boost your business and your digital projects. From the design phase to the implementation of a strategy, my speciality is supporting you at every stage of your company's growth.",
        about: 'More info',
        collaborationTitle: "Let's develop the application that suits you",
        helpTitle: 'Need help launching your next idea, or a new business?',
        helpText: "I'm  here to assist you in taking your project to the next level, providing tailored guidance and expertise every step of the way. I'll make sure your vision becomes a reality.",
        existingProductTitle: 'An existing product that needs to move forward?',
        existingProductText: 'Let’s explore how we can enhance your current solutions, optimizing performance and user experience. I will work closely with you to identify opportunities for innovation and improvement.',
        specificIssueTitle: 'Do you have a specific need? Perhaps a service provider has stood you up?',
        specificIssueText: "Together, we'll find a way to solve your problems. My commitment to finding solutions means I don't shy away from challenges - on the contrary, I welcome them to ensure you get the support you need.",
    },
    fr: {
        greeting: "Bonjour, je suis Antoine, développeur web et mobile freelance.",
        tagline: 'Boostez votre activité avec des solutions sur-mesure',
        infoline: "Développeur web polyvalent, je saurai booster votre activité et vos projets numériques. De la phase de conception à la mise en place d'une stratégie, vous accompagner à chaque étape de la croissance de votre entreprise est ma spécialité.",
        about: 'Plus d’infos',
        collaborationTitle: "Développons l'application qui vous ressemble",
        helpTitle: 'Besoin d’aide pour lancer votre prochaine idée, ou un nouveau projet ?',
        helpText: 'Je suis là pour vous aider à faire passer votre projet au niveau supérieur, en fournissant des conseils sur-mesure et une expertise à chaque étape. Je veillerai à ce que votre vision devienne réalité.',
        existingProductTitle: 'Un produit existant qui aurait besoin d’aller de l’avant ?',
        existingProductText: 'Explorons comment nous pouvons améliorer vos solutions actuelles, en optimisant les performances et l’expérience utilisateur. Je travaillerai en étroite collaboration avec vous pour identifier les opportunités d’innovation et d’amélioration.',
        specificIssueTitle: 'Un besoin spécifique ? Un prestataire vous a peut-être posé un lapin ?',
        specificIssueText: "Ensemble, nous trouverons un moyen de résoudre vos problèmes. Mon engagement à trouver des solutions signifie que je n'ai pas peur des défis, au contraire, je les accueille pour vous garantir le soutien dont vous avez besoin.",
    },
};

const services = {
    fr: [
        { title: 'Conception de site internet et applications', icon: <FaLaptopCode />, description: "Je conçois des sites web modernes et des applications qui répondent à vos besoins fonctionnels et esthétiques, tout en assurant une expérience utilisateur optimale." },
        { title: 'Mise en place et gestion de CMS', icon: <FaCogs />, description: "Je configure et administre des systèmes de gestion de contenu (CMS) pour vous permettre de gérer facilement votre contenu en ligne." },
        { title: 'Intégration web', icon: <FaCode />, description: "Je prends en charge l'intégration de designs web pour rendre votre site fonctionnel et accessible, tout en respectant les normes du web." },
        { title: 'Conception graphique & Webdesign', icon: <FaPencilRuler />, description: "Je conçois vos logos, templates web, cartes de visite et newsletters avec un design unique, moderne et professionnel." },
        { title: 'Gestion et suivi de projets web', icon: <FaProjectDiagram />, description: "Je m'occupe de la gestion complète de vos projets web, du concept initial au suivi post-lancement pour assurer le succès et la pérennité de vos projets." },
        { title: 'Conception multi-plateformes', icon: <FaMobileAlt />, description: "Je crée des sites web qui fonctionnent sur toutes les plateformes, qu'il s'agisse de smartphones, tablettes ou ordinateurs de bureau." },
        { title: 'Validation W3C, accessibilité & SEO', icon: <FaCheckCircle />, description: "Je m'assure que votre site respecte les standards W3C, est accessible à tous les utilisateurs et optimisé pour le référencement naturel." },
        { title: 'Développements spécifiques', icon: <FaTools />, description: "Je crée des outils sur-mesure adaptés à votre cœur de métier, et des solutions personnalisées pour répondre précisément à vos besoins." }
    ],
    en: [
        { title: 'Website design and applications', icon: <FaLaptopCode />, description: "I design modern websites and applications that meet your functional and aesthetic needs, while providing an optimal user experience." },
        { title: 'Implementation and management of CMS', icon: <FaCogs />, description: "I set up and manage content management systems (CMS), allowing you to easily manage your online content." },
        { title: 'Web integration', icon: <FaCode />, description: "I handle web integration to make your website functional and accessible, adhering to web standards and best practices." },
        { title: 'Graphic Design & Webdesign', icon: <FaPencilRuler />, description: "I design your logos, web templates, business cards, and newsletters with a unique, modern, and professional touch." },
        { title: 'Web project management and monitoring', icon: <FaProjectDiagram />, description: "I manage the entire lifecycle of your web projects, from initial concept to post-launch monitoring, ensuring success and long-term sustainability." },
        { title: 'Multi-platform Design', icon: <FaMobileAlt />, description: "I design websites that work seamlessly across all platforms, whether it be smartphones, tablets, or desktop computers." },
        { title: 'W3C validation, accessibility & SEO', icon: <FaCheckCircle />, description: "I ensure that your website meets W3C standards, is accessible to all users, and optimized for search engine ranking." },
        { title: 'Custom developments', icon: <FaTools />, description: "I create custom tools tailored to your business, offering personalized solutions that meet your specific needs." }
    ]
};

const words = ['solutions', 'applications', 'websites'];

const imageArray = [
    demoBloomAura,
    demoBeaulieu,
    demoOmbraStudio,
    demoComConseil,
    demoSystemik,
    demoOpus,
];
const Home: React.FC = () => {
    const { language } = useContext(LanguageContext)!;

    const [currentWordIndex, setCurrentWordIndex] = useState(0);
    const [highlightOpacity, setHighlightOpacity] = useState(1);

    useEffect(() => {
        const wordInterval = setInterval(() => {
            setHighlightOpacity(0);
            setTimeout(() => {
                setCurrentWordIndex((prevIndex) => (prevIndex + 1) % words.length);
                setHighlightOpacity(1);
            }, 500);
        }, 2800);

        return () => clearInterval(wordInterval);
    }, []);

    const sliderSettings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2500,
        arrows: false,
        adaptiveHeight: true,
    };

    const taglineParts = translations[language].tagline.split('solutions');

    const modifiedTagline = (
        <>
            {taglineParts[0]}
            <span className="highlight" style={{ opacity: highlightOpacity, transition: 'opacity 0.5s ease-in-out' }}>
                {words[currentWordIndex]}
            </span>
            {taglineParts[1]}
        </>
    );

    const fadeInUp = {
        hidden: { opacity: 0, y: 40 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.5, delay: 0.3 } }
    };

    const staggerContainer = {
        visible: { transition: { staggerChildren: 0.3 } }
    };

    const slideInFromLeft = {
        hidden: { opacity: 0, x: -120 },
        visible: { opacity: 1, x: 0, transition: { duration: 0.6 } }
    };

    const slideInFromRight = {
        hidden: { opacity: 0, x: 120 },
        visible: { opacity: 1, x: 0, transition: { duration: 0.9 } }
    };

    return (
        <motion.main
            initial="hidden"
            animate="visible"
            exit="hidden"
            className="home-container"
            variants={staggerContainer}
        >
            <motion.div
                className="home-top-section"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.5 }}
                variants={staggerContainer}
            >
                <motion.div className="home-block1" variants={fadeInUp}>
                    <h1>{translations[language].greeting}</h1>
                    <p>
                        {modifiedTagline}
                    </p>
                </motion.div>

                <motion.div className="home-block2" variants={slideInFromRight}>
                    <img src={profilePic} alt="Antoine's profile" className="profile-pic" loading="lazy" />
                    <div className="info">
                        <p>{translations[language].infoline}</p>
                        <motion.div
                            whileTap={{ scale: 0.95 }}
                            transition={{ type: "spring", stiffness: 400, damping: 23 }}
                        >
                            <Link to="/contact" className="about-link">
                                {translations[language].about}
                                <motion.img
                                    src={iconArrow}
                                    alt="arrow icon"
                                    className="arrow"
                                    loading="lazy"
                                    initial={{ x: 0 }}
                                    animate={{ x: [0, 10, 0] }}
                                    transition={{ duration: 1, repeat: Infinity, repeatType: "reverse" }}
                                />
                            </Link>
                        </motion.div>
                    </div>
                </motion.div>
            </motion.div>

            <motion.div className="home-block3" initial="hidden" whileInView="visible" viewport={{ once: true }}>
                <motion.div className="dev-activity" variants={slideInFromLeft}>
                    <img src={devActivity} alt="Developer activity" className="dev-activity-img" loading="lazy" />
                </motion.div>
                <motion.div className="help-section" variants={fadeInUp}>
                    <img src={spiralArrow} alt="Spiral arrow" className="spiral-arrow" loading="lazy" />
                    <h2>{translations[language].helpTitle}</h2>
                    <p>{translations[language].helpText}</p>
                    <h2>{translations[language].existingProductTitle}</h2>
                    <p>{translations[language].existingProductText}</p>
                    <h2>{translations[language].specificIssueTitle}</h2>
                    <p>{translations[language].specificIssueText}</p>
                </motion.div>
            </motion.div>

            <motion.div
                className="image-carousel"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                variants={fadeInUp}
            >
                <Slider {...sliderSettings}>
                    {imageArray.map((image, index) => (
                        <div key={index}>
                            <img src={image} alt={`Example slider demo ${index + 1}`} className="carousel-image" loading="lazy" />
                        </div>
                    ))}
                </Slider>
            </motion.div>

            <motion.h2
                className="collaboration-title"
                variants={fadeInUp}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
            >
                {translations[language].collaborationTitle}
            </motion.h2>

            <motion.div className="home-block4" initial="hidden" whileInView="visible" viewport={{ once: true }}>
                <div className="home-service-section">
                    {services[language].map((service, index) => (
                        <motion.div
                            key={index}
                            className="home-service-item"
                            variants={fadeInUp}
                            whileHover={{ scale: 1.03 }}
                        >
                            <div className="icon">{service.icon}</div>
                            <div><h3>{service.title}</h3></div>
                        </motion.div>
                    ))}
                </div>
                <motion.div className="image-section" variants={slideInFromRight}>
                    <img src={devConception} alt="Development conception" className="dev-conception-img" loading="lazy" />
                </motion.div>
            </motion.div>

            {/* section Projects */}
            <motion.div className="home-project-section" initial="hidden" whileInView="visible" viewport={{ once: true }}>
                <motion.div className="project-image" variants={slideInFromLeft}>
                    <img src={devDesign} alt="Dev and Design illustration" className="dev-design-img" loading="lazy" />
                </motion.div>
                <motion.div className="project-content" variants={slideInFromRight}>
                    <h2>{language === 'fr' ? 'Apporter une grande attention à chacune de vos attentes' : 'Pay close attention to your every expectation'}</h2>
                    <Link to="/projects" className="project-link">
                        <motion.button
                            className="project-button"
                            whileTap={{ scale: 0.9 }}
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ duration: 0.3 }}
                        >
                            {language === 'fr' ? 'Découvrir les projets' : 'Discover the projects'}
                        </motion.button>
                    </Link>
                </motion.div>
            </motion.div>

            <ContactBloc />
        </motion.main>
    );
};

export default Home;